angular.module("impactx").factory('$errorHandler', ['$mdDialog', '$q', function ($mdDialog, $q) {
    this.alreadyShown = false;
    var comp = this;

    this.showWarnings = function (warnings) {
        return $mdDialog.show({
            templateUrl: 'modules/error/templates/warning-dialog.tmpl.html',
            locals: {handler: comp, warnings: warnings},
            controller: 'ErrorDialogController',
            multiple: true,
            bindToController: true,
            hasBackdrop: false,
            clickOutsideToClose: true,
        });
    };

    this.showErrors = function (errors, authErrors, onClose, closeOpenDialogs, warnings) {
        if (closeOpenDialogs) {
            $mdDialog.cancel();
        }
        if (!comp.alreadyShown) {
            comp.alreadyShown = true;
            return $mdDialog.show({
                templateUrl: 'modules/error/templates/error-dialog.tmpl.html',
                locals: {handler: comp, errors: errors, authErrors: authErrors, warnings: warnings},
                controller: 'ErrorDialogController',
                multiple: true,
                bindToController: true,
                hasBackdrop: false,
                clickOutsideToClose: true,
                onRemoving: function () {
                    comp.alreadyShown = false;
                    if (onClose) {
                        onClose();
                    }
                }
            });
        }
        return $q.when();
    };

    this.showCriticalErrors = function (criticalErrors, exception) {
        $mdDialog.cancel();

        return $mdDialog.show({
            templateUrl: 'modules/error/templates/critical-error-dialog.tmpl.html',
            locals: {handler: comp, criticalErrors: criticalErrors, exception: exception},
            controller: 'ErrorDialogController',
            multiple: true,
            bindToController: true,
            clickOutsideToClose: false,
        });
    };

    return {
        showWarnings: this.showWarnings,
        showErrors: this.showErrors,
        showCriticalErrors: this.showCriticalErrors
    }
}]);